import { ofType, combineEpics } from "redux-observable";
import { tap, ignoreElements, filter, map } from "rxjs/operators";
import { mainFunctionality } from "../ducks/AnalysisStudyLogPerformanceActions.js";
import AnalysisStudyLogPerformanceConstants from "../ducks/AnalysisStudyLogPerformanceConstants.js";
import logger from "@ane/core/lib/services/logging/Logger";
import ___default from "lodash";
const CURRENT_V2_LOG_VERSION = 2.1;
const loadStart = (action$) => {
  return action$.pipe(
    ofType(
      AnalysisStudyLogPerformanceConstants.LOAD_START,
      AnalysisStudyLogPerformanceConstants.LOAD_START_V2_STUDY_LIST,
      AnalysisStudyLogPerformanceConstants.LOAD_START_V2_STUDY,
      AnalysisStudyLogPerformanceConstants.LOAD_START_V2_STUDY_TASK
    ),
    tap((action) => logger.trackMetric({ average: action.payload.clientTimeInMs, name: `PLT:${action.type}`, properties: {} })),
    // ignoreElements: This epic only needs to log LOAD_START*, so we don't need to pipe any additional actions
    ignoreElements()
  );
};
const standardMarkers = ["stepMetadataMainFunctionalityPerfEntry", "forayConfigMainFunctionalityPerfEntry"];
const mapViewToMflMarkers = {
  [AnalysisStudyLogPerformanceConstants.LOAD_START_V2_STUDY_LIST]: [
    ...standardMarkers,
    "studyAbstractsV2MainFunctionalityPerfEntry"
  ],
  [AnalysisStudyLogPerformanceConstants.LOAD_START_V2_STUDY]: [...standardMarkers, "studyAbstractV2MainFunctionalityPerfEntry"],
  [AnalysisStudyLogPerformanceConstants.LOAD_START_V2_STUDY_TASK]: [
    ...standardMarkers,
    "studyAbstractV2MainFunctionalityPerfEntry",
    "studyTaskV2MainFunctionalityPerfEntry"
  ]
};
const mapViewToMflAction = {
  [AnalysisStudyLogPerformanceConstants.LOAD_START_V2_STUDY_LIST]: AnalysisStudyLogPerformanceConstants.MAIN_FUNCTIONALITY_V2_STUDY_LIST,
  [AnalysisStudyLogPerformanceConstants.LOAD_START_V2_STUDY]: AnalysisStudyLogPerformanceConstants.MAIN_FUNCTIONALITY_V2_STUDY,
  [AnalysisStudyLogPerformanceConstants.LOAD_START_V2_STUDY_TASK]: AnalysisStudyLogPerformanceConstants.MAIN_FUNCTIONALITY_V2_STUDY_TASK
};
const v2MainFunctionality = (action$, state$) => {
  return action$.pipe(
    ofType(
      AnalysisStudyLogPerformanceConstants.STUDY_ABSTRACTS_V2_MAIN_FUNCTIONALITY,
      AnalysisStudyLogPerformanceConstants.STUDY_ABSTRACT_V2_MAIN_FUNCTIONALITY,
      AnalysisStudyLogPerformanceConstants.STUDY_TASK_V2_MAIN_FUNCTIONALITY,
      AnalysisStudyLogPerformanceConstants.STEP_METADATA_MAIN_FUNCTIONALITY,
      AnalysisStudyLogPerformanceConstants.FORAY_METADATA_MAIN_FUNCTIONALITY
    ),
    tap((action) => {
      const { loadStartTimeInMs } = state$.value.analysisStudyLogPerformanceReducer;
      const { clientTimeInMs, isCached } = action.payload;
      const timeSinceLoadStartInMs = clientTimeInMs - loadStartTimeInMs;
      logger.trackMetric({
        average: timeSinceLoadStartInMs,
        name: `PLT:${action.type}`,
        properties: { pltVersion: CURRENT_V2_LOG_VERSION, timeSinceLoadStartInMs, loadStartTimeInMs, isCached }
      });
    }),
    // if ALL MFL values we need for this view are sent then emit MAIN_FUNCTIONALITY
    filter(() => {
      const store = state$.value.analysisStudyLogPerformanceReducer;
      const requiredMarkers = store.loadStartAction && mapViewToMflMarkers[store.loadStartAction];
      return !!requiredMarkers && ___default.every(requiredMarkers, (m) => store[m]);
    }),
    tap((action) => {
      const { loadStartTimeInMs } = state$.value.analysisStudyLogPerformanceReducer;
      const timeSinceLoadStartInMs = action.payload.clientTimeInMs - loadStartTimeInMs;
      const store = state$.value.analysisStudyLogPerformanceReducer;
      const mflAction = store.loadStartAction && mapViewToMflAction[store.loadStartAction];
      const requiredMarkers = store.loadStartAction && mapViewToMflMarkers[store.loadStartAction];
      const noneCached = ___default.every(requiredMarkers, (m) => !store[m].isCached);
      logger.trackMetric({
        average: timeSinceLoadStartInMs,
        name: `PLT:${mflAction}`,
        properties: {
          lastPartToLoad: action.type,
          pltVersion: CURRENT_V2_LOG_VERSION,
          timeSinceLoadStartInMs,
          loadStartTimeInMs,
          noneCached
        }
      });
    }),
    map((action) => {
      const store = state$.value.analysisStudyLogPerformanceReducer;
      const timeSinceLoadStartInMs = action.payload.clientTimeInMs - store.loadStartTimeInMs;
      return mainFunctionality(timeSinceLoadStartInMs, action.type);
    })
  );
};
const analysisStudyLogPerformanceEpics = combineEpics(loadStart, v2MainFunctionality);
export {
  analysisStudyLogPerformanceEpics,
  loadStart,
  v2MainFunctionality
};
//# sourceMappingURL=AnalysisStudyLogPerformanceEpics.js.map
